module.exports = __webpack_public_path__ + "assets/images/project/constituencies/jurong-grc.jpg?v=42840b64";